<template>
    <img :style="inlineStyles" @click="handleClick" :src="this.element.src"/>
</template>
<script>
    import handleAction from "@mixins/HandleAction";

    export default {
        name:'ImageElement',
        props:{
            element:{
                required: true,
                type: Object
            }
        },
        mixins:[
            handleAction
        ],
        computed:{
            inlineStyles(){
                return {
                    width: '100%',
                    height: '100%',
                }
            }
        },
    }
</script>
<style scoped>
    img {
        cursor: pointer;
    }
</style>
